export default __webpack_public_path__ + "static/media/pleaseChooseEmail.5081b85f.svg";